<template>
  <div class="news">
      <div v-if="news.length > 0" class="news-wrapper">
         <OneNews  v-for="(onenews , index) in news " :key="index" :onenews="onenews" />
         <div v-if="news.length > 0" class="pagination-wrapper">
           <paginate
             v-model="page"
             :page-count="pageCount"
             :prev-text="getPaginationImages('Left')"
             :next-text="getPaginationImages('Right')"
             :container-class="'pagination'"
             :page-class="'page'"
             :click-handler="changePage"
           >
           </paginate>
         </div>
      </div>
      <div v-else class="news-wrapper">
        {{$t('main.noNews')}}
      </div>
  </div>
</template>

<script>
import OneNews from '@/components/news/OneNews.vue'
// import eventBus from '@/shared/eventBus.js'
import { api } from '@/api'

export default {
  name: 'News',
  components: {
    OneNews
  },
  data () {
    return {
      news: [],
      page: 1,
      pageCount: 0
    }
  },
  methods: {
    getNews () {
      let params = {
        page: this.page
      }
      api.getNews(params).then(res => {
        this.news = res.data.data
        this.pageCount = res.data.page_count
      }).catch(e => {
        console.log(e)
      })
    },
    getPaginationImages (side) {
      let path = require(`@/assets/icons/pagination${side}.png`)
      return `<img src='${path}' alt='pagination left image'>`
    },
    changePage (page) {
      this.page = page
      this.news = []
      this.getNews()
    }
  },
  mounted () {
    this.getNews()
  }
}
</script>

<style lang="scss" scoped>
.news{
  background: #F2F2F2;
  padding-top: 30px;
  padding-bottom: 60px;
  width: 100%;

  .news-wrapper {
  /*  display: flex; */
    height: 100%;
    max-width: 1600px;
    width: calc( 100% - 40px );
    margin: 0 auto;
    background: white;
    padding: 40px 40px;
    box-sizing: border-box;
    justify-content: center;

    .pagination-wrapper {
      max-width: 1024px;
      margin: 0 auto;
    }
  }
}

</style>
